<template>
    <CContainer class="d-flex align-items-center min-vh-100">
        <CRow class="w-100 justify-content-center">
            <CCol md="8">
                <div class="w-100">
                    <div class="clearfix">
                        <h1 class="float-left display-3 mr-4">403</h1>
                        <h4 class="pt-3">Oops! we're sorry</h4>
                        <p class="text-muted">You are not allowed to access this page.</p>
                    </div>
                </div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
export default {}
</script>